module.exports = __webpack_public_path__ + "CopingStyle4.png?9f157349b1290cfd255624012882c1e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/CopingStyle4.png
// module id = 127
// module chunks = 0